import { useTranslation } from 'react-i18next'
import type { CdRegionMode } from '../../types/changeDetection'

interface Props {
  value: CdRegionMode
  onChange: (mode: CdRegionMode) => void
  disabled?: boolean
}

const OPTIONS = [
  { mode: 'INCLUDE', labelKey: 'cd.mode.include', titleKey: 'cd.mode.includeTitle', active: 'bg-blue-600 text-white' },
  { mode: 'EXCLUDE', labelKey: 'cd.mode.exclude', titleKey: 'cd.mode.excludeTitle', active: 'bg-red-500 text-white' },
] as const satisfies readonly { mode: CdRegionMode; labelKey: string; titleKey: string; active: string }[]

/** 영역 필터 모드(포함/제외) 선택 - voxel 생성 영역과 변화탐지 분석 영역이 함께 쓴다. */
export default function CdRegionModeToggle({ value, onChange, disabled }: Props) {
  const { t } = useTranslation()
  return (
    <span className="inline-flex overflow-hidden rounded border border-slate-300 text-[10px] font-medium">
      {OPTIONS.map((o) => (
        <button
          key={o.mode}
          type="button"
          title={t(o.titleKey)}
          aria-pressed={value === o.mode}
          disabled={disabled}
          onClick={() => value !== o.mode && onChange(o.mode)}
          className={`px-1.5 py-0.5 transition disabled:opacity-40 ${
            value === o.mode ? o.active : 'bg-white text-slate-500 hover:bg-slate-50'
          }`}
        >
          {t(o.labelKey)}
        </button>
      ))}
    </span>
  )
}
